const PropTypes = require('prop-types');

// @ vendor
const React = require('react');
const { connect } = require('react-redux');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const { withRouter } = require('react-router-dom');
// @ helpers
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
// @ commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');
// @ components
const RemoveScheduledTransferSecurityConfirmation = require('components/transfers/scheduled/removeScheduledTransfer/removeScheduledTransferSecurityConfirmation/removeScheduledTransferSecurityConfirmation');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
// @ constants
const BACK_URL = '/myprofile/transfers';
// @ actions
const scheduledTransfersActions = require('actions/scheduledTransfers');

class RemoveScheduledTransferView extends React.Component {
    constructor() {
        super();
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.isReady = this.isReady.bind(this);
    }

    componentDidMount() {
        const { match: { params: { transferId, accountId } }, immScheduledTransfers, history } = this.props;

        if (!immScheduledTransfers.hasIn([accountId, 'byId', transferId, 'details'])) {
            history.push(`/myprofile/transfers/scheduled/${accountId}`);
        }
    }

    componentWillUnmount() {
        this.props.setRemoveScheduledTransferInitial();
    }

    buildSecurityConfirmationContent() {
        const { match: { params: { transferId, accountId } }, immAccounts, immScheduledTransfers, requestRemoveScheduledTransfer } = this.props;

        let content;
        if (immAccounts && immAccounts.getIn(['byId', accountId])) {
            const immAccount = immAccounts.getIn(['byId', accountId]);
            const immAccountScheduledTransfers = immScheduledTransfers.get(accountId);

            if (immAccountScheduledTransfers && immAccountScheduledTransfers.get('byOrder').size > 0) {
                const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
                const cancelText = formatText('wizard-redirectConfirmationCancelButton');
                const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
                const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
                const immScheduledTransfer = immAccountScheduledTransfers.getIn(['byId', transferId]);

                content = (
                    <div>
                        <PreLeaveModalComponent
                            acceptText={acceptText}
                            confirmationMessage={confirmationMessage}
                            confirmationTitle={confirmationTitle}
                            cancelText={cancelText}
                            isReady={this.isReady}
                        />
                        <RemoveScheduledTransferSecurityConfirmation
                            accountId={accountId}
                            transferId={transferId}
                            isRemoving={immScheduledTransfers.get('isRemoving')}
                            immScheduledTransfer={immScheduledTransfer}
                            immAccount={immAccount}
                            onRemoveClick={requestRemoveScheduledTransfer}
                            backUrl={BACK_URL}
                        />
                    </div>
                )
            }
        }

        return content;
    }

    buildSuccessfulContent() {
        const { match: { params: { transferId, accountId } }, immScheduledTransfers } = this.props;

        const immAccountScheduledTransfers = immScheduledTransfers.get(accountId);
        const immScheduledTransfer = immAccountScheduledTransfers.getIn(['byId', transferId]);
        const beneficiaryName = [immScheduledTransfer.getIn(['details', 'name'])];

        const goBackButtonLabel = formatText('transfersScheduled-removeScheduledTransferSuccessReturnLbl').toUpperCase();
        const goBackButton = {
            label: goBackButtonLabel,
            url: BACK_URL
        };
        const message = formatText('transfersScheduled-removeScheduledTransferSuccessMessage', beneficiaryName);
        return (
            <WizardSuccess
                successSubMessage={message}
                mainButton={goBackButton}
            />
        );
    }

    buildWizardError() {
        const { match: { params: { accountId } } } = this.props;

        const errorTitle = formatText('transfersScheduled-errorRemoveTitle');
        const errorMessage = <FormattedText value="transfersScheduled-errorRemovey" />;
        const goBackButtonLabel = formatText('transfersScheduled-removeScheduledTransferSuccessReturnLbl').toUpperCase();
        const linkToScheduledTransfers = `/myprofile/transfers/scheduled/${accountId}`;

        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToScheduledTransfers
        };

        return (
            <article className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <WizardError errorMessage={errorTitle} errorSubMessage={errorMessage} mainButton={goBackButton} />
                </div>
            </article>
        );
    }

    isReady() {
        return false;
    }

    render() {
        const { match: { params }, immScheduledTransfers } = this.props;
        const accountId = params.accountId;
        const scheduledTransfersUrl = `/myprofile/transfers/scheduled/${accountId}`;
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-transfers'),
                url: '/myprofile/transfers'
            },
            {
                text: formatText('transfersLanding-scheduledTranfers'),
                url: scheduledTransfersUrl
            },
            {
                text: formatText('breadcrumb-remove')
            }
        ];

        let bodyContent;
        if (immScheduledTransfers.get('submitSuccessful')) {
            bodyContent = this.buildSuccessfulContent();
        } else if (immScheduledTransfers.get('removeError')) {
            bodyContent = this.buildWizardError();
        } else {
            bodyContent = this.buildSecurityConfirmationContent();
        }

        return (
            <article className="remove-scheduled-transfer-view">
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="transfers" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('transfersScheduled-removeScheduledTransferSubpageTitle')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-negative" id="printable-wizard">
                        {bodyContent}
                    </div>
                </div>
            </article>
        );
    }
}

RemoveScheduledTransferView.propTypes = {
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immScheduledTransfers: PropTypes.object.isRequired,
    setRemoveScheduledTransferInitial: PropTypes.func.isRequired,
    requestRemoveScheduledTransfer: PropTypes.func.isRequired
};

module.exports.RemoveScheduledTransferView = connect(
    state => ({
        immAccounts: state.accounts,
        immScheduledTransfers: state.scheduledTransfers
    }), {
        setRemoveScheduledTransferInitial: scheduledTransfersActions.setRemoveScheduledTransferInitial,
        requestRemoveScheduledTransfer: scheduledTransfersActions.requestRemoveScheduledTransfer,
    })(withRouter(RemoveScheduledTransferView));
